export class MindeeApiError extends Error {
  constructor(statusCode, body) {
    super(`Mindee API error (${statusCode}): ${body}`);
    this.name = "MindeeApiError";
    this.statusCode = statusCode;
    this.body = body;
  }
}

async function blobToBase64(blob) {
  const buffer = await blob.arrayBuffer();
  const bytes = new Uint8Array(buffer);
  let binary = "";
  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
}

function handleErrorResponse(res, rawText) {
  let errorMsg = `Server error (${res.status}): ${rawText}`;
  try {
    const parsed = JSON.parse(rawText);
    if (parsed.error) {
      errorMsg = parsed.error;
    }
  } catch {
    // Response wasn't JSON
  }
  throw new MindeeApiError(res.status, errorMsg);
}

/**
 * Sends a single card image to the server-side /api/scan endpoint.
 */
export async function analyzeInsuranceCard(imageBlob, endpoint) {
  const base64 = await blobToBase64(imageBlob);

  const res = await fetch(endpoint || "https://cardscan.fastdevcompany.com/api/scan", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ image: base64 }),
  });

  if (!res.ok) {
    handleErrorResponse(res, await res.text());
  }

  const { data } = await res.json();
  return data;
}

/**
 * Sends front and back card images to the server in a single request.
 */
export async function analyzeDualSideCard(frontBlob, backBlob, endpoint) {
  const [frontBase64, backBase64] = await Promise.all([blobToBase64(frontBlob), blobToBase64(backBlob)]);

  const res = await fetch(endpoint || "https://cardscan.fastdevcompany.com/api/scan", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ frontImage: frontBase64, backImage: backBase64 }),
  });

  if (!res.ok) {
    handleErrorResponse(res, await res.text());
  }

  const json = await res.json();
  return { front: json.front, back: json.back };
}
